export default "__VITE_ASSET__BpbdVfLN__"